// `CliLicenseScanned` means that the source code was already scanned for licenses by the CLI and we are downloading the license scan results from S3.
// `Archive` means that we are going to download and then scan an archive from S3 containing source code. This can come from the CLI or from the UI.
// `SBOM` means that we are going to download and then scan an archive from S3 containing the SBOM file (cyclonedx or spdx). This can come from the UI.
export enum FileType {
  CliLicenseScannedFullFiles = 'cli_license_scan_full_files',
  CliLicenseScannedMatchData = 'cli_license_scan_match_data',
  Archive = 'archive',
  SBOM = 'sbom',
  FirstPartyScan = 'first_party_scan',
}
